// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","756":"component---src-pages-privacy-policy-tsx"}[chunkId] || chunkId) + "-" + {"245":"53575c78e4f36417bc6f","453":"044774629dd57931ed56","454":"09a9d5bac06033ceafdc","756":"6f2f7dc2f47e858abad9"}[chunkId] + ".js";
};